import React from "react";
import "./App.css";
import "fontsource-roboto";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import theme from "./theme";
import Home from "./pages/Home";
import Competitions from "./pages/Competitions";
import Team from "./pages/Team";
import Results from "./pages/Results";
import { Router, Redirect, Switch, Route, Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import logo from "./assets/images/logo.png";
import { createBrowserHistory } from "history";

const useStyles = makeStyles((theme) => ({
  logo: {
    height: "35px",
    verticalAlign: "middle",
  },
  root: {
    display: "flex",
    width: "100%",
    minHeight: "100vh",
    flexDirection: "column",
  },
  title: {
    textAlign: "left",
    flexGrow: 1,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },

  footer: {
    backgroundColor: "#3b3b3b",
    color: "white",
    marginTop: "auto",
    // marginTop: theme.spacing(8),
    padding: theme.spacing(2, 0),
  },
}));
function Copyright() {
  return (
    <Typography variant="body2" align="center">
      {"Copyright © "}
      <Link style={{ color: "white" }} to="/">
        American Science Tournaments Association
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export const history = createBrowserHistory();

history.listen((location, action) => {
  let body = document.getElementsByTagName("BODY")[0];
  body.style.scrollBehavior = "auto";
  body.scrollTo({ top: 0, behavior: "auto" });
  body.style.scrollBehavior = "";
});

function App() {
  const routes = [
    { path: "/about", Component: Competitions },
    { path: "/team", Component: Team },
    { path: ["/results/standings", "/results/individuals", "/results/scoreboard", "/results/teamdetail", "/results/individualdetail", "/results"], Component: Results },
    { path: "/", Component: Home },
  ];
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <header className="App-header">
          <Router history={history}>
            <div className={classes.root}>
              <CssBaseline />
              <AppBar className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                  <div className={classes.title}>
                    <Link to="/">
                      <img alt="ASTA" className={classes.logo} src={logo} />
                    </Link>
                  </div>
                  <Button color="inherit" component={Link} to="/">
                    Home
                  </Button>
                  <Button color="inherit" component={Link} to="/about">
                    About
                  </Button>
                  <Button color="inherit" component={Link} to="/team">
                    Team
                  </Button>
                  <Button color="inherit" component={Link} to="/results/standings">
                    Results
                  </Button>
                  <Button
                    color="inherit"
                    component="a"
                    href="https://portal--asta-tournaments.netlify.app"
                  >
                    Portal
                  </Button>
                </Toolbar>
              </AppBar>
              <main className={classes.content}>
                <div className={classes.appBarSpacer} />
                <Switch>
                  {routes.map(({ path, Component, props }) => (
                    <Route key={path} exact path={path}>
                      <Component {...props} />
                    </Route>
                  ))}
                  <Redirect to="/" />
                </Switch>
              </main>
              <footer className={classes.footer}>
                <Container maxWidth="sm">
                  <Copyright />
                </Container>
              </footer>
            </div>
          </Router>
        </header>
      </div>
    </ThemeProvider>
  );
}

export default App;
